module.exports = __webpack_public_path__ + "img/card_icon_v1_mastercard.ae9cba8a.svg";